import $ from 'jquery';
import jQuery from 'jquery';
import validate from 'jquery-validation';

// This file can either be included from WGrant as is or the maintainers can host on their own server and modify to their hearts content.
// Setting LDA_DOMAIN and LDA_REDIRECT constants prior to including this javascript overrides the defaults

var service = typeof LDA_DOMAIN != 'undefined' ? LDA_DOMAIN : 'https://lda.hendricksgin.com';
var src = service;
var rdr = typeof LDA_REDIRECT != 'undefined' ? LDA_REDIRECT : service + '/lda';

var overlay = $('#wgs_lda_overlay');
var lda = $('#lda');

$(document).ready(function() {

    $("form#wgs_lda").validate({
        ignore: [],
        submitHandler: function (form) {
            $('#lda_message').text("Please wait ...");
            // form.submit();
            $.post(form.action, $("form#wgs_lda").serialize(), function(data) {
                if (data.result == 'SUCCESS') {

                    // Save cookie so we don't have to show it again.
                    createCookie('passedLDA', 1, 182);
                    createCookie('wgs_lda', data.payload, 182);

                    // Retrieve payload to calculate redirect
                    if(data.payload) var payload = JSON.parse(decodeURIComponent(data.payload));

                    hideLDA();

                } else {
                    // Here we redirect to the LDA page or show a modal. Up to the website maintainers.
                    // As long as the LDA form posts to the global LDA check page, we don't care.
                    showLDA();

                    if (data.result == 'ERROR' && data.message != '') {
                        $('#lda_message').text(data.message);
                        $('#lda_message').addClass('alert error');
                    }

                    // Redirect to Responsibility.org if US was chosen.
                    if (typeof data.country != 'undefined' && data.country != '') {
                        if (data.country.toLowerCase() == 'us') {
                            window.location.href = "https://www.responsibility.org";
                        }
                    }
                }

            });
        }
    });

    if (typeof readCookie != 'undefined' && readCookie('passedLDA') != 1) {

        var iframe = document.createElement('iframe');
        var dom = window.location.protocol + "//" + window.location.hostname;

        iframe.style.display = "none";
        iframe.src = src + '?LDA_DOMAIN=' + dom + '&LDA_REDIRECT=' + rdr;
        iframe.name = 'wgs_lda_redirector';

        document.body.appendChild(iframe);

        // Create IE + others compatible event handler
        var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
        var eventer = window[eventMethod];
        var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

        // Listen to message from child window
        eventer(messageEvent, function (e) {
            // if (e.origin == service || e.origin.indexOf('lda.') >= 0) {

                var data = e.data || { result: 'ERROR', message: 'You are not old enough to enter this site.'};


            // This can redirect to whatever url we receive from the iframe
                if (data.result == 'ok') {

                    // Save cookie so we don't have to show it again.
                    createCookie('passedLDA', 1, 182);
                    createCookie('wgs_lda', e.data.payload, 182);

                    // Retrieve payload to calculate redirect
                    var payload = JSON.parse(decodeURIComponent(e.data.payload));

                    hideLDA();

                } else {
                    // Here we redirect to the LDA page or show a modal. Up to the website maintainers.
                    // As long as the LDA form posts to the global LDA check page, we don't care.
                    showLDA();

                    if (data.result == 'ERROR' && data.message != '') {
                        $('#lda_message').text(data.message);
                        $('#lda_message').addClass('alert error');
                    }

                    // Redirect to Responsibility.org if US was chosen.
                    if (typeof e.data.country != 'undefined' && e.data.country != '') {
                        if (e.data.country.toLowerCase() == 'us') {
                            window.location.href = "https://www.responsibility.org";
                        }
                    }
                }
            // }
        }, false);

    } else {
        if (document.getElementById('wgs_lda_overlay')) {
            document.getElementById('wgs_lda_overlay').remove();
        }
    }

    function showLDA()
    {
        lda.show();
    }

    function hideLDA()
    {
        var child = document.getElementById('lda');
        child.parentNode.removeChild(child);

        var child = document.getElementById('wgs_lda_overlay');
        child.parentNode.removeChild(child);
    }

    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    function createCookie(name, value, days) {
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
        } else var expires = "";
        document.cookie = name + "=" + value + expires + "; path=/";
    }

});
